import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Star">{props.title || 'Star'}</title>
      <g>
        <path d="M256.3 402.4l-157 93.2 40.2-178.1-137.2-120.5 181.8-16.9 72.2-167.7 72.2 167.7 181.8 16.9-137.1 120.5 40.1 178.1z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/star.js